module.exports = __webpack_public_path__ + "post-listing-block-2-trulia-yL5ekOl.png";